import { render, staticRenderFns } from "./PresaleSetting.vue?vue&type=template&id=5ebb0c26&scoped=true"
import script from "./PresaleSetting.vue?vue&type=script&lang=js"
export * from "./PresaleSetting.vue?vue&type=script&lang=js"
import style0 from "./PresaleSetting.vue?vue&type=style&index=0&id=5ebb0c26&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ebb0c26",
  null
  
)

export default component.exports